import React, { memo } from "react";
import { Chip } from "@mui/material";
import { ICellRendererParams } from "ag-grid-community";

import { Swab } from "ui";

import { formatNumber } from "fond/utils/number";

import { getScoreChipColors, getScoreColor } from "../helper";

import { CellWrapper } from "./scoreCellRenderer.styles";

interface ScoreCellRendererParams {
  variant?: "chip";
}

const ScoreCellRenderer: React.FC<ICellRendererParams> = memo((params: ICellRendererParams & ScoreCellRendererParams) => {
  const color = getScoreColor(params.value);

  if (params.variant === "chip") {
    const label = params.value == null || params.value === -1 ? "-" : formatNumber(params.value, 0);
    const chipColors = getScoreChipColors(params.value ?? -1);
    return (
      <CellWrapper>
        <Chip
          size="small"
          label={label}
          sx={{
            backgroundColor: chipColors.bg,
            color: chipColors.fg,
            fontWeight: 600,
            fontSize: 10,
            minWidth: "max-content",
            height: 16,
          }}
        />
      </CellWrapper>
    );
  }

  return (
    <CellWrapper>
      <Swab color={color || "#000"} />
    </CellWrapper>
  );
});

ScoreCellRenderer.displayName = "ScoreCellRenderer";

export default ScoreCellRenderer;
